import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    paddingBottom: 16,
    justifyContent: 'space-between', //not pushing footer and content apart
    flexGrow: 1,
    backgroundColor: `#FFF`,
  },
  bannerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 3,
  },
  background: {
    width: '100%',
    height: 180,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  imageBackgroundStyle: {
    overflow: 'hidden',
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '90%',
    marginTop: 40,
    position: 'relative',
  },
  textContainer: {
    alignItems: 'flex-start',
  },
  greetingText: {
    color: themes.light.brand_blue[3],
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: 'SF Pro Display, sans-serif',
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: 1,
  },
  questionText: {
    textAlign: 'center',
  },
  truckImage: {
    width: 168,
    height: 80,
    position: 'absolute',
    top: 59,
    // bottom: -118, //need to inspect this for large screen respoonsivness
    right: 23,
  },
  dataContainer: {
    gap: 12,
  },
  companyDetailsContainer: {
    gap: 6,
    borderBottomWidth: 1,
    borderColor: themes.light.gray_blue[6],
  },
  typeDateContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
  },
  detailsHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderColor: themes.light.gray_blue[6],
    paddingHorizontal: 10,
    paddingVertical: 8,
    gap: 16,
  },
  companyName: {
    flexShrink: 1,
    maxWidth: '80%',
  },
  companyTypeContainer: {
    flex: 1,
    flexDirection: 'column',
    gap: 6,
    padding: 10,
  },
  companyLabel: {
    color: themes.light.gray_blue[3],
  },
  companyType: {
    fontWeight: 600,
  },
  dotMcContainer: {
    gap: 12,
    borderBottomWidth: 1,
    borderColor: themes.light.gray_blue[6],
    marginBottom: 6,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dotNumberContainer: {
    flex: 1,
    gap: 6,
    padding: 10,
  },
  dotNumberLable: {
    color: themes.light.gray_blue[3],
  },
  dotNumber: {
    fontWeight: 600,
  },
  mcNumberContainer: {
    flex: 1,
    gap: 6,
    padding: 10,
  },
  mcNumberLabel: {
    color: themes.light.gray_blue[3],
  },
  mcNumber: {
    fontWeight: 600,
  },
  garagingAddressContainer: {
    gap: 6,
    borderBottomWidth: 1,
    borderColor: themes.light.gray_blue[6],
    padding: 10,
    justifyContent: 'flex-start',
  },
  garagingAddressLabel: {
    color: themes.light.gray_blue[3],
  },
  garagingAddress: {
    // fontWeight: 600,
  },
  mailingAddressContainer: {
    gap: 6,
    borderBottomWidth: 1,
    borderColor: themes.light.gray_blue[6],
    padding: 10,
    justifyContent: 'flex-start',
  },
  mailingAddressLabel: {
    color: themes.light.gray_blue[3],
  },
  mailingAddress: {
    // fontWeight: 600,
  },
  prevAuthorityContainer: {
    flexDirection: 'row',
    gap: 24,
    borderBottomWidth: 1,
    borderColor: themes.light.gray_blue[6],
    marginBottom: 6,
    padding: 10,
    alignItems: 'center',
  },
  toastContainer: {
    paddingHorizontal: 16,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    paddingVertical: 12,
    paddingHorizontal: 12,
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '50%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '100%', // Restrict to 67% width
  },
  consentContainer: {
    paddingHorizontal: 0,
  },
  consentText: {
    color: themes.light.gray_blue[3],
    fontSize: 9,
  },
  consentLink: {
    color: themes.light.brand_blue[3],
    textDecorationLine: 'none',
    fontSize: 9,
  },

  // Version 2 banner
  bannerV2: {
    // gap: 24,
    backgroundColor: themes.light.brand_blue[7],
    paddingTop: 24,
    paddingHorizontal: 10,
  },
  bannerV2Content: {
    gap: 14,
  },
  bannerV2Title: {
    fontSize: 28,
    fontWeight: '100',
  },
  bannerV2TitleHighlight: {
    fontSize: 28,
    fontWeight: '800',
    color: themes.light.brand_blue[3],
  },

  bannerV2List: {
    gap: 10,
  },
  bannerV2ListItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
    gap: 8,
  },
  bannerV2ListIcon: {
    width: 20,
    height: 20,
    // marginRight: 8,
  },
  bannerV2ListText: {},

  bannerV2Truck: {
    width: 120,
    height: 46,
    alignSelf: 'flex-end', // push it all the way to the right
  },

  bannerV2Cta: {
    flexDirection: 'row',
    backgroundColor: themes.light.brand_blue[4],
    borderBottomRightRadius: 20,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  bannerV2CtaText: {
    flex: 1,
    color: themes.light.white[1],
  },
  bannerV2CtaIcon: {
    width: 32,
    height: 32,
    marginLeft: 8,
  },
});
